// extracted by mini-css-extract-plugin
module.exports = {"footerBackground":"Footer_footerBackground__teoWe","footer":"Footer_footer__23AIx"};